import { createFileRoute } from "@tanstack/react-router";

import { DomainInitForm } from "@/features/onboarding/components/domain-init-form";
import { DomainVerification } from "@/features/onboarding/components/domain-verification";
import { useCurrentTenant } from "@/features/tenant/api/use-current-tenant";

export const Route = createFileRoute("/_authed/onboarding/domain")({
  component: OnboardingDomainPage,
});

/** Port of onboarding/1-Domain.vue — subdomain init, then DNS verification. */
function OnboardingDomainPage() {
  const { data: tenant } = useCurrentTenant();

  if (!tenant) {
    return null;
  }

  if (!tenant.tenantBranding?.postmarkappDomain) {
    return <DomainInitForm tenant={tenant} />;
  }

  return <DomainVerification tenant={tenant} />;
}
